import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "../../libs/utils";

function Dialog({ open, onOpenChange, children }) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      {children}
    </DialogPrimitive.Root>
  );
}

function DialogTrigger({ children }) {
  return <DialogPrimitive.Trigger asChild>{children}</DialogPrimitive.Trigger>;
}

const getEventTarget = (event) => {
  const target = event.detail?.originalEvent?.target || event.target;

  return target instanceof Element ? target : null;
};

const isPaginatedSelectMenuEvent = (event) =>
  Boolean(getEventTarget(event)?.closest("[data-paginated-select-menu]"));

function DialogContent({
  children,
  className,
  onInteractOutside,
  onPointerDownOutside,
  ...props
}) {
  const handleInteractOutside = (event) => {
    if (isPaginatedSelectMenuEvent(event)) {
      event.preventDefault();
      return;
    }

    onInteractOutside?.(event);
  };

  const handlePointerDownOutside = (event) => {
    if (isPaginatedSelectMenuEvent(event)) {
      event.preventDefault();
      return;
    }

    onPointerDownOutside?.(event);
  };

  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-[1000] bg-black/50 backdrop-blur-sm" />
      <DialogPrimitive.Content
        className={cn(
          "fixed left-[50%] top-[50%] z-[1001] max-h-[calc(100dvh-2rem)] w-[calc(100vw-1.5rem)] max-w-md translate-x-[-50%] translate-y-[-50%] overflow-y-auto rounded-xl bg-white p-4 shadow-2xl sm:w-[calc(100vw-2rem)] sm:p-6",
          className
        )}
        onInteractOutside={handleInteractOutside}
        onPointerDownOutside={handlePointerDownOutside}
        {...props}
      >
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}

function DialogHeader({ children }) {
  return <div className="mb-4">{children}</div>; 
}

function DialogTitle({ children }) {
  return (
    <DialogPrimitive.Title className="text-lg font-semibold text-slate-900">
      {children}
    </DialogPrimitive.Title>
  );
}

function DialogDescription({ children }) {
  return (
    <DialogPrimitive.Description className="py-2 text-sm text-slate-500">
      {children}
    </DialogPrimitive.Description>
  );
}

function DialogClose({ children }) {
  return <DialogPrimitive.Close asChild>{children}</DialogPrimitive.Close>;
}

export {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
};
